'use client';

import { useEffect, useState } from 'react';

import type { GenericHeaderProps } from '@eliadmin/core/src/components/header/header-client';

import { HeaderMain } from '@eliadmin/core/src/components/header/header-main';
import { HeaderNotification } from '@eliadmin/core/src/components/header/header-notification';
import { Topbar } from '@eliadmin/core/src/components/header/topbar';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function DefaultHeader(props: GenericHeaderProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let frameId = 0;

    const updateScrolledState = () => {
      const nextScrolled = window.scrollY > 100;
      setScrolled(previous => (previous === nextScrolled ? previous : nextScrolled));
      frameId = 0;
    };

    const handleScroll = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(updateScrolledState);
    };

    updateScrolledState();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.cancelAnimationFrame(frameId);
    };
  }, []);

  return (
    <>
      <Topbar items={props.topbarItems} />
      <header
        className={cn(
          'sticky left-0 top-0 z-40 flex w-full flex-col transition-shadow',
          'ea-default-header',
        )}
        style={{
          boxShadow: scrolled ? '0px 16px 32px 0px #0000001F' : '0px 16px 32px 0px #00000000',
          transition: 'box-shadow 0.4s ease',
        }}
      >
        <HeaderMain {...props} />
      </header>
      <HeaderNotification generalLayout={props.generalLayout} />
    </>
  );
}
